import {
  EnumField,
  Field,
} from '../../util/components/resource/resource-fields/resource-fields';
import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import {
  MessageChannelCategory,
  messageChannelCategoryLabels,
} from './lib/message-channel.interfaces';

@Endpoint('message-channels', 'MessageChannel')
export class MessageChannel extends ApiResource<MessageChannel> {
  @Field()
  reference!: string;

  @Field()
  name!: string;

  @EnumField({
    label: $localize`Category`,
    type: () => MessageChannelCategory,
    enumLabels: messageChannelCategoryLabels,
  })
  category?: MessageChannelCategory;

  @Field({ includeFilter: false })
  channelUrl!: string;
}
